import hyperdom from 'hyperdom'
import browserWarningBanner from './browserWarningBanner.jsx'
import formatPrice from './packages/ui-helpers/formatPrice.js'
import assetPath from './assetPath.js'
import * as gtmDataLayer from './analytics/gtm/dataLayer.js'

export default class Header {
  constructor (options) {
    this.config = options.config
    this.user = options.user
    this.showFaq = options.showFaq
    this.priceReady = options.priceReady
    this.total = options.total
    this.api = options.api
    this.sso = options.sso
    this.browserCapabilities = options.browserCapabilities
    this.logo = options.logo
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  logout () {
    return this.sso.logout()
      .then(() => this.logoutBookingEngine())
      .catch(err => {
        console.error("Could not log out of SSO", err)
        return this.logoutBookingEngine()
      })
  }

  logoutBookingEngine () {
    return this.api.logout().then(() => window.location.reload())
  }

  toggleContext () {
    this.contextOpen = !this.contextOpen
  }

  renderConsumerHelp () {
    if (this.user.role !== 'consumer') return

    return <p class='page-header__help'>
      {
        this.config.sellingCompanyCode
          ? <div>
            <strong>Need some help?</strong> Call us on <span class='page-header__phone-icon'>{this.config.phone.general}</span><br />
            {
              this.showFaq()
                ? <span>or <strong><a href='#faq' onclick='return false;'>read the FAQ</a></strong></span>
                : <span>&nbsp;</span>
            }
          </div>
          : ''
      }
    </p>
  }

  renderUserWelcome () {
    if (this.user.firstName && this.user.lastName) {
      return <div>
        <div class='page-header__user' onclick={() => this.toggleContext()}>
          <div>
            <div class='page-header__user__name'>{this.user.firstName} {this.user.lastName}</div>
            <i class='icon-down-user' />
          </div>
          { this.user.organisation ? <div class='page-header__user__org'>{this.user.organisation}</div> : '' }
        </div>
        { this.contextOpen
          ? <ul class='page-header__user__context-menu'>
            <li class='page-header__user__context-menu__user-summary'>
              <div>
                <span>{this.user.firstName} {this.user.lastName}</span>
                <i class='icon-down-user' />
              </div>
              { this.user.organisation ? <div class='page-header__user__org'>{this.user.organisation}</div> : '' }
            </li>
            <li><a href='#logout' class='logout' onclick={e => { e.preventDefault(); this.logout() }}>Sign out</a></li>
          </ul>
          : ''
        }
      </div>
    }
  }

  render () {
    return <header class={['page-header', `role-${this.user.role}`]}>
      {
        browserWarningBanner({browserCapabilities: this.browserCapabilities})
      }
      <div class='page-header__inner u-clearfix'>
        <div class='page-header__logo-wrapper'>
          <a href={this.user.isTravelAgent ? this.config.brandPages.travelAgentHomePage : this.config.brandPages.brandWebsite}>
            <img class='page-header__logo' src={assetPath(`/public/img/brand-logos/${this.logo || this.config.brandLogo}`)} alt={this.config.brandName} />
          </a>
        </div>
        <div class='page-header__content'>
          {this.renderConsumerHelp()}
          {this.renderUserWelcome()}
          <p class='page-header__price'>
            {
              this.priceReady()
                ? <span>
                  <a href='#summary' onclick='return false'>{formatPrice(this.total())}</a>
                </span>
                : <span>&nbsp;</span>
            }
          </p>
        </div>
      </div>
    </header>
  }
}
